<template>
  <div id="contenedor-funcionarios-default">
    <v-container
      fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <!-- ToolBar -->
          <titulo-tool-bar></titulo-tool-bar>
          <tool-bar
            class="mb-4"
            v-on:nuevoFuncionario="registrarNuevoFuncionario"
            v-on:buscar="buscar"
            >
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card
        flat>
        <v-card-text>
          <!-- Loader -->
          <v-skeleton-loader
            v-if="$apollo.loading"
            type="table-heading, table-thead, table-tbody"
          ></v-skeleton-loader>
          <listado
            v-if="!$apollo.loading"
            :listado="getFuncionarios">
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- Ventana para registrar nuevo funcionario -->
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevoFuncionario"
      :width="!$vuetify.breakpoint.mobile ? '50%' : '90%'">
      <registrar-nuevo-funcionario
        v-if="mostrarVentanaRegistrarNuevoFuncionario"
        v-on:cerrar="cerrarRegistrarNuevoFuncionario">
      </registrar-nuevo-funcionario>
    </v-dialog>
    <!-- Ventana para editar funcionario -->
    <v-dialog
    v-if="esteFuncionario"
      v-model="mostrarVentanaEditarFuncionario"
      :width="!$vuetify.breakpoint.mobile ? '50%' : '90%'">
      <editar-funcionario
      :funcionarioEditar="esteFuncionario"
        v-on:cerrar="cerrarEditarFuncionario">
      </editar-funcionario>
    </v-dialog>
    <!-- Ventana para eliminar funcionario -->
    <v-dialog
    v-if="esteFuncionario"
      v-model="mostrarVentanaEliminarFuncionario"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <eliminar-funcionario
      :funcionarioEliminar="esteFuncionario"
        v-on:cerrar="cerrarRemoverFuncionario">
      </eliminar-funcionario>
    </v-dialog>
  </div>
</template>

<script>
import FUNCIONARIOS from '@/graphql/querys/administracion/catalogos/funcionarios/funcionarios.gql';
import TituloToolBar from './TituloToolBar.vue';
import RegistrarNuevoFuncionario from '@/components/administracion/configuracion/catalogos/funcionarios/Nuevo.vue';
import EditarFuncionario from '@/components/administracion/configuracion/catalogos/funcionarios/Editar.vue';
import EliminarFuncionario from '@/components/administracion/configuracion/catalogos/funcionarios/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'FuncionariosDefault',
  components: {
    TituloToolBar,
    RegistrarNuevoFuncionario,
    EditarFuncionario,
    EliminarFuncionario,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarVentanaRegistrarNuevoFuncionario: false,
      mostrarVentanaEditarFuncionario: false,
      mostrarVentanaEliminarFuncionario: false,
      esteFuncionario: null,
      buscarTexto: '',
    };
  },
  mounted() {
    eventBus.$on('editar-funcionario', (funcionario) => {
      this.esteFuncionario = funcionario;
      this.mostrarVentanaEditarFuncionario = true;
    });
    eventBus.$on('eliminar-funcionario', (funcionario) => {
      this.esteFuncionario = funcionario;
      this.mostrarVentanaEliminarFuncionario = true;
    });
  },
  methods: {
    buscar(buscarTexto) {
      this.buscarTexto = buscarTexto;
    },
    registrarNuevoFuncionario() {
      this.mostrarVentanaRegistrarNuevoFuncionario = true;
    },
    cerrarRegistrarNuevoFuncionario() {
      this.mostrarVentanaRegistrarNuevoFuncionario = false;
    },
    cerrarEditarFuncionario() {
      this.mostrarVentanaEditarFuncionario = false;
      this.esteFuncionario = null;
    },
    cerrarRemoverFuncionario() {
      this.mostrarVentanaEliminarFuncionario = false;
      this.esteFuncionario = null;
    },
  },
  apollo: {
    funcionarios: {
      query: FUNCIONARIOS,
    },
  },
  computed: {
    getFuncionarios() {
      if (!this.funcionarios) return [];
      return this.funcionarios
        .filter((funcionario) => {
          if (!this.buscarTexto) return funcionario;
          const expt = new RegExp(this.buscarTexto, 'gi');

          const nombre = this.$normalizacionTexto(funcionario.nombre);
          const puesto = this.$normalizacionTexto(funcionario.puesto);

          return (
            expt.test(nombre)
            || expt.test(puesto)
            || expt.test(funcionario.nombre)
            || expt.test(funcionario.puesto)
          );
        })
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
  },
};
</script>

<style lang="scss">

</style>
